// extracted by mini-css-extract-plugin
export default {"root":"SummaryRow_root__Bm-Xj","label":"SummaryRow_label__rA+Sn","value":"SummaryRow_value__I3Pzs","loaderLine":"SummaryRow_loaderLine__8KEgQ","loader":"SummaryRow_loader__nqdbX"};